import React from "react";
import { Campo, Opcion, Pregunta, inputCls } from "./ui";

export const validarPaso1 = (f) => {
  if (!f.titulo.trim()) return { campo: "titulo", txt: "Escribe el nombre del recordatorio." };
  if (!f.aviso && f.modo !== "correo") return { campo: "que", txt: "Selecciona al menos una opción." };
  if (f.importe !== "" && !(Number(f.importe) >= 0)) return { campo: "importe", txt: "Escribe solo la cantidad, por ejemplo 350." };
  return null;
};

export const PasoQue = ({ f, set, error }) => (
  <div className="space-y-5">
    <Campo label="Nombre del recordatorio" ayuda="Por ejemplo: Pagar el alquiler" error={error?.campo === "titulo" && error.txt} testid="rp-campo-titulo">
      <input data-testid="rp-titulo" className={inputCls} value={f.titulo} maxLength={150} placeholder="Pagar el alquiler" onChange={(e) => set({ titulo: e.target.value })} />
    </Campo>
    <Pregunta>¿Qué quieres que haga AL DÍA?</Pregunta>
    <div className="space-y-3">
      <Opcion testid="rp-modo-aviso" casilla sel={f.aviso} onClick={() => set({ aviso: !f.aviso })} titulo="Quiero un aviso" texto="AL DÍA te recordará que debes hacerlo." />
      <Opcion testid="rp-modo-correo" casilla sel={f.modo === "correo"} onClick={() => set({ modo: f.modo === "correo" ? "aviso" : "correo" })} titulo="Quiero preparar un correo" texto="AL DÍA dejará preparado el mensaje para que tú lo revises y lo envíes." />
      {error?.campo === "que" && <p data-testid="rp-error-que" role="alert" className="text-base font-semibold text-[#B91C1C]">{error.txt}</p>}
    </div>
    <Campo label="¿Cuánto hay que pagar?" opcional ayuda="Déjalo en blanco si no hay que pagar nada." error={error?.campo === "importe" && error.txt} testid="rp-campo-importe">
      <div className="relative">
        <input data-testid="rp-importe" type="number" inputMode="decimal" min="0" step="0.01" className={`${inputCls} pr-10`} value={f.importe} placeholder="0" onChange={(e) => set({ importe: e.target.value })} />
        <span className="absolute right-4 top-1/2 -translate-y-1/2 text-lg text-[#6E7A74]">€</span>
      </div>
    </Campo>
    {f.verNotas ? (
      <Campo label="Nota" opcional testid="rp-campo-nota">
        <textarea data-testid="rp-nota" rows={3} className={`${inputCls} py-3`} value={f.notas} onChange={(e) => set({ notas: e.target.value })} />
      </Campo>
    ) : (
      <button type="button" data-testid="rp-anadir-nota" onClick={() => set({ verNotas: true })} className="min-h-[48px] text-base font-semibold text-[#3A6B56] underline underline-offset-4">+ Añadir una nota</button>
    )}
  </div>
);
